/**
 * Shared `trackAction` registry.
 *
 * Each platform registers its own implementation (web → eventBuffer.ts on
 * load; mobile → src/lib/trackAction.ts on App startup). Services then call
 * `trackAction(name, metadata)` without caring which platform they're on.
 *
 * Default impl is a no-op so SSR / Node / tests don't blow up.
 */

type TrackActionFn = (name: string, metadata?: Record<string, unknown>) => void;

let impl: TrackActionFn = () => {};

export function setTrackActionImpl(fn: TrackActionFn) {
  impl = fn;
}

export function trackAction(name: string, metadata?: Record<string, unknown>) {
  try {
    impl(name, metadata);
  } catch {
    // never let telemetry break a real flow
  }
}
